<style src="./ContextSaleFilter.scss" lang="scss"></style>
<template>
  <section class="context-sale-filter">
    <form @submit.prevent="openModalConfirm" class="rowsection">
      <span class="filtertitle">Aplicar Valor</span>
      <div class="filters">
        <select
          class="cp1-small-select field marginright"
          v-model="form.fieldName">
          <option
            v-for="(filterType, filterTypeIdx) in lists.fields"
            :key="filterTypeIdx"
            :value="filterType">{{ filterType }}</option>
        </select>
        <select
          class="cp1-small-select operator marginright"
          v-model="form.operator">
          <option
            v-for="(filterType, filterTypeIdx) in lists.operators"
            :key="filterTypeIdx"
            :value="filterType">{{ filterType }}</option>
        </select>
        <input
          type="text"
          v-model="form.value"
          placeholder="10"
          class="cp1-small-textbox inputoperand marginright" />
        <select
          class="cp1-small-select valuetype marginright"
          v-model="form.valueType">
          <option
            v-for="(filterType, filterTypeIdx) in lists.valueTypes"
            :key="filterTypeIdx"
            :value="filterType">{{ filterType }}</option>
        </select>
        <button
          class="cp1-small-button cp1-button__success filterbutton">
          Aplicar
        </button>
      </div>
    </form>

    <modal
      transition="nice-modal-fade"
      name="modalConfirmAddSale"
      width="500px"
      height="auto">
      <aside class="modal-confirm">
        <icon-danger class="illustration" />

        <div class="description">
          <p class="info">
            Essa ação irá afetar os itens atualmente exibidos na coluna <strong>VENDA - V.UNIT</strong>
          </p>
          <p class="info">
            Tem certeza que deseja continuar?
          </p>
        </div>

        <section class="cmdcancel">
          <button
            type="button"
            @click="cancelApply"
            class="btn-ghost">Cancelar ação</button>
        </section>
        <form
          @submit.prevent="applySaleValue"
          class="cmdapply">

          <button-submit
            label="Sim, pode alterar os valores"
            :state="commands.submitState"
            :icon-save="commands.saveIcon" />
        </form>
      </aside>
    </modal>
  </section>
</template>

<script>
import { ButtonSubmit } from '@/components/primitives'
import { IconRightArrow, IconDanger, IconSave } from '@/components/primitives/icons'
import CalculateSaleFilter from '../../helpers/CalculateSaleFilter'

export default {
  name: 'ContextSaleFilter',
  components: {
    ButtonSubmit,
    IconRightArrow,
    IconDanger,
    IconSave
  },
  data: () => ({
    form: {
      fieldName: 'ESTIMADO',
      operator: '-',
      value: '10',
      valueType: '%'
    },
    lists: {
      fields: [
        'CUSTO',
        'ESTIMADO',
        'MÁXIMO'
      ],
      operators: [
        '+',
        '-'
        // '+*',
        // '-*',
        // '±*'
      ],
      valueTypes: [
        '%',
        'R$'
      ]
    },
    commands: {
      submitState: 'REPOSE',
      saveIcon: IconSave
    }
  }),
  mounted () {},
  methods: {
    cancelApply () {
      this.$modal.hide('modalConfirmAddSale')
    },
    openModalConfirm () {
      this.$modal.show('modalConfirmAddSale')
    },
    async applySaleValue () {
      const eventId = this.$route.params.id
      if (!eventId) return false
      this.commands.submitState = 'WAIT'

      const selectedItems = this.$store.getters['ItemPricing/FILTERED_LIST']
      const calculateMath = CalculateSaleFilter({ ...this.form })
      const payload = selectedItems.map(i => calculateMath(i))

      try {
        await this.$store.dispatch('ItemPricing/UPDATE_SALE_LIST', { payload })
        await this.$store.dispatch('ItemPricing/LIST_ALL_ITEMS', { eventId })
        this.$toasted.success('Atualização salva com sucesso!')
      } catch (error) {
        this.$toasted.error(error)
      } finally {
        this.commands.submitState = 'REPOSE'
        this.$modal.hide('modalConfirmAddSale')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/item-pricing/components/context-sale-filter/ContextSaleFilter.vue